
let obtenerLabelEtiqueta = (control, listEtiquetas) => {


  if (listEtiquetas.length > 0) {


    let valor;
    listEtiquetas.map((etiquetas) => {
      if (etiquetas.ccontrol == control) {

        valor = etiquetas.nomenclatura;
      }
    });

    return valor;


  }
};

export { obtenerLabelEtiqueta };
